<template>
  <router-link class="chair" tag="div" :to="`/chair/detail?id=${data.ID}`" v-if="obj && Object.keys(obj).length > 0">
    <div class="fj">
      <img :src="C.setAvatar(data.ImagePath, '')" />
      <img class="play-video" style="width:38px;height:38px;" src="./../assets/images/ico_play_btn@2x.png"/>
    </div>
    <div class="name" v-if="nameShow">
      <img :src="obj.Lecturer.imgSrc" />
      <span style="margin-left:6px;">{{data.Lecturer.Name}}</span>
    </div>
    <h4>{{data.Name}}</h4>
    <div v-if="isContList" class="info">
      <span>{{data.Publisher}} {{data.PublishLecTime.slice(5)}}</span>
      <div>
        <span
          ><img :src="require('../assets/images/start@2x.png')" />
          {{data.Favorites}}</span
        >
        <span
          ><img :src="require('../assets/images/dianzan.png')" />
          {{data.Likes}}</span
        >
      </div>
    </div>
    <div class="label">
      <div class="left">
        <img :src="require('../assets/images/ico_drug@2x.png')" />
        <template v-if=" typeof(data.LectureLibraryString) == 'string'">
          <span>{{data.LectureLibraryString}}</span>
        </template>
        <template v-else>
          <span v-for="(item,index)  in data.LectureLibrarys" :key="index">{{item.KeyName}}</span> 
        </template>
        <!-- -->
        
      </div>
      <div class="right" v-if="isContList">
        <span>{{data.LectureClassName}}</span>
      </div>
    </div>
  </router-link>
</template>
<script>
import * as C from '@/utils/const'
export default {
  props: {
    nameShow: {
      type: Boolean,
      default: false,
    },
    isContList: {
      type: Boolean,
      default: false,
    },
    data: {
      type:Object,
      default:()=>{}
    },
    
  },
  data(){
    return{
      C:{},
      obj:{}
    }
  },
  mounted(){
    this.C = C
    this.obj = this.data;
    if (this.nameShow) {
      this.obj.Lecturer.imgSrc = C.setAvatar(this.obj.Lecturer.Photo.Path, this.obj.Lecturer.PhotoUrl)
      console.log(this.obj)
    }

  }
};
</script>
<style lang="scss" scoped>
.chair {
  width: 180px;
  margin: 20px 20px 38px 0;
  cursor: pointer;
  & > div.fj {
    position: relative;
    img {
      width: 100%;
      height: 101px;
    }
    .play-video{
      width: 38px;
      height: 38px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-31px,-31px);
    }
    p {
      position: absolute;
      font-size: 12px;
      color: #fff;
      left: 9px;
      bottom: 4px;
    }

  }
  h4 {
    font-weight: bold;
    color: #606266;
    margin: 10px 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .info {
    color: #909399;
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    span{
      img {
        width: 14px;
        vertical-align: middle;
        margin-left: 10px;
        
      }
      &:first-child{
        img {
          width: 11px;
        }
      }
    }
    
  }
  .label {
    color: #909399;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    .left {
      img {
        width: 12px;
        height: 12px;
        margin-right: 8px;
      }
      span {
        margin-right: 10px;
      }
    }
    .right {
      color: #c0c4cc;
    }
  }
  .name {
    display: flex;
    align-items: center;
    margin-top: -10px;
    position: relative;
    margin-left: 5px;
    img {
      width: 32px;
      height: 32px;
      border: 4px solid #fff;
      border-radius: 50%;
    }
    span {
      color: #606266;
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/YChair.vue